import axios from 'CanExConfig/axios'

export const fetchOnlineProfiles = async id => {
  const response = await axios.get(`/api/candidate/v2/candidate_profiles/${id}/online_profiles`)
  return response.data.result
}

export const updateOnlineProfiles = async (data, id) => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/online_profiles`, {
    method: 'PATCH',
    data,
  })

  return response.data.result
}
